import React from 'react';
export function ThirdSlide() {
  return <div className="w-full min-h-screen bg-[#222222]" data-id="element-144">
      {/* Mobile Layout */}
      <div className="md:hidden flex flex-col" data-id="element-145">
        {/* Image first on mobile */}
        <div className="w-full" data-id="element-146">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8x69VWQKMFYfAaPH15rNgx/Madeleine-Morlet_1.jpg" alt="Mother and child sitting" className="w-full h-auto object-contain" data-id="element-147" />
        </div>

        {/* Text content below image */}
        <div className="px-6 py-12 text-white" style={{
        fontFamily: 'Georgia, serif',
        fontSize: '11px',
        lineHeight: '1.6'
      }} data-id="element-148">
          <p className="mb-6" data-id="element-149">
            <span className="font-bold" data-id="element-150">VANESSA PIZZICHINI</span> is a
            London-based image director and former stylist, with over ten years
            of industry experience. Her clients have included luxury brands such
            as Burberry and Chanel, as well as cultural institutions including
            the National Theatre and the Design Museum. She is also a mother.
          </p>

          <p className="mb-10" data-id="element-151">
            <span className="font-bold" data-id="element-152">MADELEINE MORLET</span> is a
            London-based photographer and writer. She is a former editor of the
            indie print publication{' '}
            <span className="italic" data-id="element-153">Teeth Magazine</span>, and has worked with{' '}
            <span className="italic" data-id="element-154">Dazed</span>,{' '}
            <span className="italic" data-id="element-155">Vice</span>, and{' '}
            <span className="italic" data-id="element-156">i-D</span>, bringing over a decade of
            editorial experience. She is also a mother.
          </p>

          <div className="font-mono" style={{
          fontSize: '7.5px'
        }} data-id="element-157">
            <h3 className="font-bold mb-4" data-id="element-158">CONTACTS</h3>

            <div className="mb-4" data-id="element-159">
              <p data-id="element-160">
                Vanessa Pizzichini <span className="italic" data-id="element-161">Editor</span>
              </p>
              <p data-id="element-162">vanessa@thefourthmag.com</p>
              <p data-id="element-163">+44 7780 616942</p>
            </div>

            <div data-id="element-164">
              <p data-id="element-165">
                Madeleine Morlet <span className="italic" data-id="element-166">Editor</span>
              </p>
              <p data-id="element-167">madeleine@thefourthmag.com</p>
              <p data-id="element-168">+44 7809 607972</p>
              <p className="mt-2" data-id="element-169">
                <a href="https://www.instagram.com/thefourthmagazine/" target="_blank" rel="noopener noreferrer" className="hover:underline" data-id="element-170">
                  INSTAGRAM
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden md:flex min-h-screen justify-start items-center py-16" data-id="element-171">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8x69VWQKMFYfAaPH15rNgx/Madeleine-Morlet_1.jpg" alt="Mother and child sitting" className="w-auto object-cover" style={{
        maxHeight: 'calc(100vh - 8rem)'
      }} data-id="element-172" />

        <div className="flex-1 flex items-end justify-end px-12 lg:px-20" data-id="element-173">
          <div className="text-white" style={{
          fontFamily: 'Georgia, serif',
          fontSize: '11px',
          lineHeight: '1.6',
          maxWidth: '320px'
        }} data-id="element-174">
            <p className="mb-6" style={{
            marginTop: '88px'
          }} data-id="element-175">
              <span className="font-bold" data-id="element-176">VANESSA PIZZICHINI</span> is a
              London-based image director and former stylist, with over ten
              years of industry experience. Her clients have included luxury
              brands such as Burberry and Chanel, as well as cultural
              institutions including the National Theatre and the Design Museum.
              She is also a mother.
            </p>

            <p className="mb-10" data-id="element-177">
              <span className="font-bold" data-id="element-178">MADELEINE MORLET</span> is a
              London-based photographer and writer. She is a former editor of
              the indie print publication{' '}
              <span className="italic" data-id="element-179">Teeth Magazine</span>, and has worked
              with <span className="italic" data-id="element-180">Dazed</span>,{' '}
              <span className="italic" data-id="element-181">Vice</span>, and{' '}
              <span className="italic" data-id="element-182">i-D</span>, bringing over a decade of
              editorial experience. She is also a mother.
            </p>

            <div className="font-mono" style={{
            fontSize: '7.5px'
          }} data-id="element-183">
              <h3 className="font-bold mb-4" data-id="element-184">CONTACTS</h3>

              <div className="mb-4" data-id="element-185">
                <p data-id="element-186">
                  Vanessa Pizzichini <span className="italic" data-id="element-187">Editor</span>
                </p>
                <p data-id="element-188">vanessa@thefourthmag.com</p>
                <p data-id="element-189">+44 7780 616942</p>
              </div>

              <div data-id="element-190">
                <p data-id="element-191">
                  Madeleine Morlet <span className="italic" data-id="element-192">Editor</span>
                </p>
                <p data-id="element-193">madeleine@thefourthmag.com</p>
                <p data-id="element-194">+44 7809 607972</p>
                <p className="mt-2" data-id="element-195">
                  <a href="https://www.instagram.com/thefourthmagazine/" target="_blank" rel="noopener noreferrer" className="hover:underline" data-id="element-196">
                    INSTAGRAM
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}